var Giant = Giant || {};

(function($, window, document, undefined) {

    var pluginName = 'cloner',
        defaults = {
            item: 'tr', // item selector
            target: 'tbody', // element where new items will be placed
            position: 'append', // append | prepend | after | before
            template: '.template', // template selector
            min: 0, // TODO
            max: null, // TODO // null = unlimited count
            indexType: 'integer', // required for autoindexing items, type time|incremental, time only for now
            indexName: 'index', // default index name used in template
            confirm: 'Opravdu chcete odebrat tuto položku?' // confirmation message before removing
        },
        emmiter = $({}),
        $window = $(window);

    function Cloner(element, options) {
        this.scope = element;
        this.$scope = $(element);

        this.options = $.extend({}, defaults, options);

        this.$emmiter = $({});

        this._defaults = defaults;
        this._name = 'cloner';

        this.init();
    }

    Cloner.SILENT = true;

    Cloner.prototype = {

        positions: ['after', 'before', 'append', 'prepend'],

        init: function() {
            var self = this;

            this.counter = -1; // for integer indexing

            this.$emmiter
                .on('add', self.add.bind(self))
                .on('remove', function(event, button) {
                    self.remove(button);
                })
                .on('removeExisting', function(event, button) {
                    self.removeExisting(button);
                });


            var $template = this.$scope.find(this.options.template);

            // separate html and script tags
            if ($template.prop('tagName').toLowerCase() === 'script') {
                this.template = $template.text();
            } else {
                $template.remove().removeClass('template');
                var $temp = $('<' + ($template.prop('tagName') === 'tr' ? 'tbody' : 'div') + '>');
                this.template = $temp.append($template).html();
            }

            this.$target = this.$scope.find(this.options.target);

            this.check();

            return this;
        },

        emmit: function(eventType, args) {
            this.$emmiter.trigger(eventType, args);
            return this;
        },

        off: function() {
            this.$scope.off('.cloner');
            return this;
        },

        add: function(silent) {
            var item = this.template,
                regexp = new RegExp('{' + this.options.indexName + '}', 'g'),
                position = $.inArray(this.options.position, this.positions) ? this.options.position : 'append';

            if (this.options.indexType === 'time') {
                item = this.template.replace(regexp, Date.now());
            }

            if (this.options.indexType === 'integer') {
                item = this.template.replace(regexp, this.counter--);
            }

            var $item = $(item);

            this.$target[position]($item);

            this.$scope.trigger('cloneradd', $item);
            this.$scope.trigger('clonerchange');
            $item.trigger('change:dom');

            if (!silent) this.check();

            return this;
        },

        getItem: function(button) {
            return $(button).closest(this.options.item);
        },

        remove: function(button) {
            var self = this,
                message = $(button).data('cloner-confirm') || this.options.confirm,
                $item = this.getItem(button);

            if (confirm(message)) {
                this.$scope.trigger('clonerremove', $item.detach());
                this.$scope.trigger('clonerchange');
            } else {
                this.$scope.trigger('clonercancel', $item);
            }

            this.check();

            return this;
        },

        removeExisting: function(button) {
            var self = this,
                message = $(button).data('cloner-confirm') || this.options.confirm,
                $item = this.getItem(button);

            if (confirm(message)){
                // IE 8 can't dynamicaly replace type attribute
                var $input = $item.find('input');
                $input.replaceWith($('<input type="hidden" value="1" name="' + $input.attr('name') + '">'));
                $item.hide();
                this.$scope.trigger('clonerremove', $item);
                this.$scope.trigger('clonerchange');
            } else {
                this.$scope.trigger('clonercancel');
            }
            return this;
        },

        check: function() {
            var count = this.$target.find(this.options.item).length;

            if (this.options.min) {
                if (count > this.options.min) {
                    this.$scope.removeClass('cloner-min');
                } else {
                    this.$scope.addClass('cloner-min');
                }

                // auto add new item if min is set
                if (count < this.options.min) {
                    for (var i = 0; i < this.options.min; i++) {
                        this.add(Cloner.SILENT);
                    }
                }
            }

            if (this.options.max) {
                if (count < this.options.max) {
                    this.$scope.removeClass('cloner-max');
                } else {
                    this.$scope.addClass('cloner-max');
                }
            }

            return this;
        }
    };

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin-' + pluginName)) {

                // parse data-options
                var data = $(this).data(),
                    options = {};

                if (pluginName in data && $.type(data[pluginName]) === 'object') {
                    options = data[pluginName];
                }

                $.each(defaults, function(key, value) {
                    var option = pluginName + key.substr(0,1).toUpperCase() + key.substr(1);

                    if (option in data) {
                        options[key] = data[option];
                    }
                });

                if ('min' in options) {
                    options.min = parseInt(options.min, 10);
                }

                if ('max' in options) {
                    options.max = parseInt(options.max, 10);
                }

                $.data(this, 'plugin-' + pluginName, new Cloner(this, options));
            }
        });
    };

    $.fn[pluginName].defaults = defaults;

    $(document)
        .on('click.cloner', '[data-cloner-action]', function(event) {
            event.preventDefault();
            var $this = $(this),
                cloner = $this.closest('[data-cloner]').cloner().data('plugin-cloner');

            cloner.emmit($this.data('cloner-action'), $this);
        })
        .on('change:dom', function(event) {
            $('[data-cloner]', event.target).cloner();
        });

    $('[data-cloner]').cloner();

    Giant.Cloner = Cloner;

})(jQuery, window, document);